import { Suspense, useState } from "react";
import ScreenLoader from "../../Loader/ScreenLoader";
import { Outlet } from "react-router";
import logo from "@/assets/images/Prud_Logo.png";
import BrokerIcon from "@/assets/images/Prud_favicon.svg";
import UiButton from "@/UI-Components/Buttons/UiButton";
import { ChevronDown, ChevronLeft } from "lucide-react";
import { useGetAdminMenu } from "@/services/hooks/adminMenu/useGetAdminMenu";
import { SIDE_MENU } from "../sidebar.constant";
import useGlobalRoutesHandler from "@/hooks/useGlobalHandleRouter";
import UiImage from "@/UI-Components/Image/UiImage";

const DefaultSidebar = () => {
  const { navigate, activeRoutes } = useGlobalRoutesHandler();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [expandedMenu, setExpandedMenu] = useState<number | null>(null);

  const {
    services: { getAllAdminMenu },
  } = useGetAdminMenu();

  const menuFromApi = getAllAdminMenu?.data?.menus?.map((item) => item.slug);

  return (
    <div className="flex items-center justify-start bg-lightGray/30 ">
      <div
        className={`relative flex flex-col gap-4 transition-all duration-200 ease-in-out bg-lightGray/30 px-3 py-2  h-screen  ${
          isSidebarOpen ? "w-64" : "w-24"
        }`}
      >
        <div className=" flex items-center justify-center w-full h-16 border-b-gray-100 ">
          <UiImage
            src={isSidebarOpen ? logo : BrokerIcon}
            data-open={isSidebarOpen}
            className={`w-10 data-[open=true]:w-30 mix-blend-darken`}
            alt="logo"
          />
        </div>

        <UiButton
          buttonType="tertiary"
          icon={
            <ChevronLeft
              className={`size-5 ${
                !isSidebarOpen ? "rotate-[-180deg]" : "rotate-0"
              }`}
            />
          }
          className="w-8 absolute top-10 -right-3 z-20 bg-lightGray h-8 border border-lightGray"
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        />
        <div
          className={`h-[calc(100%-50px)] overflow-y-auto overflow-x-hidden hide-scroll flex flex-col mt-2 ${!isSidebarOpen ? "gap-2" : ""}`}
        >
          {SIDE_MENU.filter(
            (item) =>
              menuFromApi?.includes(item.slug) ||
              (item.submenus &&
                item.submenus?.some((submenu) =>
                  menuFromApi?.includes(submenu.slug)
                ))
          ).map((menu) => {
            const hasSubmenus = menu.submenus?.length;
            const isMenuActive =
              (menu.route && activeRoutes?.includes(menu.route)) ||
              (menu.submenus &&
                menu.submenus.some((submenu) =>
                  activeRoutes?.includes(submenu.route)
                ));

            const Icon = menu.icon;

            return (
              <div
                key={menu?.id}
                className="flex flex-col rounded-lg cursor-pointer "
              >
                {isSidebarOpen ? (
                  <>
                    <div
                      className={`flex items-center justify-between  text-sm text-nowrap p-2 tracking-wider  ${isMenuActive ? "bg-white rounded-sm text-primary" : "text-black/90 "} hover:bg-lightGray`}
                      onClick={() => {
                        if (menu.route) navigate(menu.route);
                        if (!hasSubmenus) return;
                        setExpandedMenu(
                          expandedMenu === menu.id ? null : menu.id
                        );
                      }}
                    >
                      <div className="flex gap-2 items-center">
                        <span> {Icon && <Icon className="size-5 " />}</span>
                        <span className="text-sm font-bo  ">{menu.name}</span>
                      </div>
                      <span>
                        {hasSubmenus && (
                          <ChevronDown
                            className={`size-4 transform transition-transform duration-300
                              ${expandedMenu === menu.id ? "rotate-180" : "rotate-0"}`}
                          />
                        )}
                      </span>
                    </div>
                    <div
                      className={`flex flex-col py-1 gap-1 ${expandedMenu === menu.id ? " border-l-2 border-lightGray ml-3  my-2" : ""}`}
                    >
                      {expandedMenu === menu.id &&
                        menu?.submenus
                          ?.filter((submenu) =>
                            menuFromApi?.includes(submenu.slug)
                          )
                          .map((each) => {
                            const isActiveRoute = activeRoutes?.includes(
                              each.route
                            );

                            return (
                              <div
                                key={each?.id}
                                className="flex flex-col  items-start ml-3 "
                              >
                                <UiButton
                                  buttonType="tertiary"
                                  text={each?.name}
                                  className={`text-sm p-2 flex  justify-end flex-row-reverse text-right text-nowrap w-40 
    ${isActiveRoute ? "text-primary bg-white" : "hover:bg-lightGray"}
  `}
                                  onClick={() => navigate(each?.route)}
                                />
                              </div>
                            );
                          })}
                    </div>
                  </>
                ) : (
                  <UiButton
                    buttonType="tertiary"
                    icon={Icon && <Icon className="size-5 text-gray-800" />}
                    className={`p-2 bg-lightGray ${isMenuActive ? "bg-white rounded-sm " : ""}`}
                    onClick={() => {}}
                  />
                )}
              </div>
            );
          })}
        </div>
      </div>
      <Suspense fallback={<ScreenLoader />}>
        <Outlet />
      </Suspense>
    </div>
  );
};

export default DefaultSidebar;
